import 'const'
import { StyleProvider } from '@ant-design/cssinjs'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import { LayoutProvider } from 'components/Layout'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import { MessageProvider } from 'hooks'
import ReactDOM from 'react-dom/client'
import { theme } from 'theme'
import './index.css'
import reportWebVitals from './reportWebVitals'
import { Router } from './router'

dayjs.locale('zh-cn')

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  // <StrictMode>
  <LayoutProvider
    config={{
      appCode: 'cbs',
    }}
  >
    <StyleProvider>
      <ConfigProvider locale={zhCN} theme={theme}>
        <MessageProvider>
          <Router />
        </MessageProvider>
      </ConfigProvider>
    </StyleProvider>
  </LayoutProvider>
  // </StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
